export enum inviteUserModal {
  'inviteStudents' = 'inviteStudents',
  'addStudents' = 'addStudents',
  'inviteTeachers' = 'inviteTeachers'
}
